module.exports = __webpack_public_path__ + "static/media/Self-Storage-300x250.07d6b251.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ads/Self-Storage-300x250.gif
// module id = 36
// module chunks = 0